/* @flow */
import AuthActions from 'auth/AuthActions';
import BoxBody from 'components/BoxBody.jsx';
import Device from 'entities/Device';
import DialogContent from 'components/DialogContent.jsx';
import enumerate from 'lib/enumerate';
import JoinEmailAccountUpgradeForm from './JoinEmailAccountUpgradeForm.jsx';
import JoinPageLoadingIndicator from './JoinPageLoadingIndicator.jsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import invariant from 'invariant';

const STATUS = enumerate(['confirming', 'form']);

type Props = {
  location: {
    query: Object,
  },
  params: Object,
};

type State = {
  token: string,
  verificationToken: string,
  status: string,
  error: string,
};

class JoinConfirmEmailDevicePage extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props: Props) {
    super(props);
    const query = props.location.query;
    const verificationToken = query.verification_token;
    invariant(verificationToken, 'missing verificationToken in JoinConfirmEmailDevicePage');
    const { token } = query;
    invariant(token, 'missing token in JoinConfirmEmailDevicePage');
    this.state = {
      token,
      verificationToken,
      status: STATUS.confirming,
      error: '',
    };
  }

  componentDidMount() {
    const onSessionExchangeError = () => {
      this.setState({
        error: 'Link might have expired.',
      });
    };

    const confirmEmailDevice = user => {
      const onSuccess = () => {
        if (user.hasPassword()) {
          this.context.router.push(`/join/${this.props.params.groupCode}`);
        } else {
          this.setState({ status: STATUS.form });
        }
      };

      const onError = () => {
        this.setState({ error: 'Cannot confirm email.' });
      };

      Device.confirmEmailDevice(this.state.verificationToken).then(onSuccess, onError);
    };

    AuthActions.accessTokenSignIn(this.state.token).then(
      confirmEmailDevice,
      onSessionExchangeError
    );
  }

  redirectToInfoPage = () => {
    const groupCode = this.props.params.groupCode;
    this.context.router.push(`/information_required/${groupCode}`);
  };

  renderAccountForm = () => {
    return <JoinEmailAccountUpgradeForm onDone={this.redirectToInfoPage} />;
  };

  renderConfirming = () => {
    if (this.state.error) {
      return (
        <DialogContent size="small" title={'An error occured'}>
          <BoxBody divided>{this.state.error}</BoxBody>
        </DialogContent>
      );
    }

    return <JoinPageLoadingIndicator />;
  };

  render() {
    return {
      [STATUS.confirming]: this.renderConfirming,
      [STATUS.form]: this.renderAccountForm,
    }[this.state.status]();
  }
}

export default JoinConfirmEmailDevicePage;
